import { Link } from 'react-router-dom';
import { categories } from '@/mocks/anime';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-foreground-200">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-play-circle-fill text-lg text-white"></i>
              </div>
              <span className="text-lg font-heading font-bold text-white">91动漫</span>
            </div>
            <p className="text-sm text-foreground-400 leading-relaxed">
              正版高清动漫在线观看平台，海量番剧资源，流畅观番体验。让每一位动漫爱好者畅享极致观番乐趣。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">快速导航</h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">首页</Link>
              <Link to="/category/rexue" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">分类浏览</Link>
              <Link to="/#ranking" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">番剧排行</Link>
              <Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">关于我们</Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">热门分类</h4>
            <div className="flex flex-col gap-2">
              {categories.slice(0, 5).map((cat) => (
                <Link
                  key={cat.id}
                  to={`/category/${cat.slug}`}
                  className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">联系我们</h4>
            <div className="flex flex-col gap-2 text-sm text-foreground-400">
              <p>邮箱：contact@91anime.com</p>
              <p>微博：@91动漫官方</p>
              <p>微信：91动漫公众号</p>
              <Link to="/about" className="text-primary-400 hover:text-primary-300 transition-colors whitespace-nowrap">查看更多 →</Link>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-700 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; 2020-2026 91动漫 版权所有 | 正版高清动漫在线观看平台
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors whitespace-nowrap">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors whitespace-nowrap">用户协议</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors whitespace-nowrap">版权声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}